var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "stickynote",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0V3.5",
    transform: "translate(9.333 2.333)",
    fill: "none",
    stroke: "#1a1944",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0V3.5",
    transform: "translate(18.667 2.333)",
    fill: "none",
    stroke: "#1a1944",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H9.333",
    transform: "translate(8.167 12.833)",
    fill: "none",
    stroke: "#1a1944",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H5.833",
    transform: "translate(8.167 17.5)",
    fill: "none",
    stroke: "#1a1944",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M14,21.583H7c-5.833,0-7-2.4-7-7.21v-7.2C0,1.692,1.948.222,5.833,0h9.333C19.052.21,21,1.692,21,7.175v7.408",
    transform: "translate(3.5 4.083)",
    fill: "none",
    stroke: "#1a1944",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M7,0,0,7V3.5Q0,0,3.5,0Z",
    transform: "translate(17.5 18.667)",
    fill: "none",
    stroke: "#1a1944",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    fill: "none",
    opacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsBlack);
export default __webpack_public_path__ + "static/media/reportsBlack.c5fd52b71c105f6f68284742fbc539fe.svg";
export { ForwardRef as ReactComponent };